import React from "react";
import styled from "styled-components";
// import common components
import Typography, { TYPE_ELEMENTS } from "./Typography";

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  // max-width: 200px;

  @media (max-width: 640px) {
    max-width: 100%;
    gap: 4px;
  }
`;

const LinkItem = styled.a`
  text-decoration: none;
  display: block;
  color: #fff;
  cursor: pointer;

  :hover {
    color: ${(props) => (props.noHover === "true" ? "#fff" : "#ff4f00")};
  }
`;

const TextItem = styled.div`
  display: block;
  color: #fff;
  cursor: pointer;

  :hover {
    color: ${(props) => (props.noHover === "true" ? "#fff" : "#ff4f00")};
  }
`;

export default function FooterLinkSection({
  header = "",
  items = [],
  onSelect = () => {},
  hasLink = true,
  isTextOnly = false,
}) {
  if (isTextOnly) {
    return (
      <SectionContainer>
        <Typography typeElement={TYPE_ELEMENTS.BODY_2} customWeight="700">{header}</Typography>
        {items.map((item, index) => (
          <TextItem key={index} noHover={true}>
            <Typography key={index} typeElement={TYPE_ELEMENTS.CAPTION}>
              {item}
            </Typography>
          </TextItem>
        ))}
      </SectionContainer>
    );
  }

  return (
    <SectionContainer>
      <Typography typeElement={TYPE_ELEMENTS.BODY_2} customWeight="700">{header}</Typography>
      {hasLink
        ? items.map((item, index) => (
            <LinkItem key={index} href={item.LINK} noHover={false}>
              <Typography key={index} typeElement={TYPE_ELEMENTS.CAPTION}>
                {item.LABEL}
              </Typography>
            </LinkItem>
          ))
        : items.map((item, index) => (
            <LinkItem
              key={index}
              onClick={() => onSelect({ LABEL: item.LABEL, ITEMS: item.ITEMS })}
              noHover={false}
            >
              <Typography typeElement={TYPE_ELEMENTS.CAPTION}>
                {item.LABEL}
              </Typography>
            </LinkItem>
          ))}
    </SectionContainer>
  );
}
